import { render } from "./GeneralDetailsSection.vue?vue&type=template&id=ba80d5b2&scoped=true"
import script from "./GeneralDetailsSection.vue?vue&type=script&lang=js"
export * from "./GeneralDetailsSection.vue?vue&type=script&lang=js"

import "./GeneralDetailsSection.vue?vue&type=style&index=0&id=ba80d5b2&scoped=true&lang=css"

import exportComponent from "F:\\CodeBrix\\My Porter\\WECCO-UserFlow\\MyPorter\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba80d5b2"]])

export default __exports__